export const numberToPrecision = (value: number, precision: number, forceZeroes?: boolean): string => {
    const stringy = value.toString();
    if ((stringy.includes('.') && stringy.split('.').pop()!.length > precision) || forceZeroes) {
        return value.toFixed(precision);
    }
    return stringy;
};
